// @vendors
import { useState } from 'react';
import { useLazyQuery } from '@apollo/client';

// @queries
import { GET_LOAD_STATUS } from 'api/queries';

// @constants
import { LoadStatus } from 'constants/loadConstants/loadConstants';

interface CarrierCharge {
  EnteredByUserId: number;
  ChargeTypeId: number;
  Units: number;
  CostPerUnit: number;
  Quantity: number;
  TotalCost: number;
  Comment: string;
  EnteredOn: string;
  LoadCarrierCostId: number;
}

interface LoadBookByCommittedCapacityResponseLoad {
  LoadBoardId: number;
  LoadStatus: string;
  CarrierCharges: CarrierCharge[];
  DriverInfo: any;
}

interface LoadBookByCommittedCapacityResponse {
  bookLoadInCommittedCapacity: {
    Load: LoadBookByCommittedCapacityResponseLoad;
    Success: boolean;
  }
}

interface Args {
  changeTenderStatus: () => void;
  tenderDetails: any;
}

export function useBookedTender({ changeTenderStatus, tenderDetails }: Args) {
  const [loadingMessage, setLoadingMessage] = useState('Getting Load Details');
  const [wasSuccessfullBook, setWasSuccessfullBook] = useState(null);

  const [
    getLoadStatus,
    { data: loadStatus, loading: loadingLoadStatus }
  ] = useLazyQuery(GET_LOAD_STATUS, {
    variables: {
      loadNumber: tenderDetails.loadNumber
    },
    onCompleted: (data) => {
      if (data?.getLoadStatus?.LoadStatusTypeId) {
        const isLoadStatusBooked = loadStatus.getLoadStatus.LoadStatusTypeId === Number(LoadStatus.BOOKED);
        if (isLoadStatusBooked) {
          changeTenderStatus();
        }
        setWasSuccessfullBook(isLoadStatusBooked);
        setLoadingMessage('');
      }
    }
  });

  const onCompletedLoadBooking = (res: LoadBookByCommittedCapacityResponse) => {
    if (res.bookLoadInCommittedCapacity.Success) {
      getLoadStatus()
    }
  };

  const onErrorLoadBooking = () => {
    setWasSuccessfullBook(false);
    setLoadingMessage('');
  };

  return {
    getLoadStatus,
    onCompletedLoadBooking,
    onErrorLoadBooking,
    loadingLoadStatus,
    loadingMessage,
    setLoadingMessage,
    wasSuccessfullBook
  };
}
